import styles from './Wordmark.module.css'

/**
 * The mark and the name, as one link home.
 *
 * public/mark.svg is the app's own ensō. app/ronin/tools/build_mark.py writes it here and
 * into the app in one run, so the two cannot drift. It is a fixed two-colour logo, so an
 * <img> is right here: nothing about it should follow the text colour.
 */
export default function Wordmark({ size = 28 }: { size?: number }) {
  return (
    <span className={styles.wordmark}>
      <img src="/mark.svg" alt="" width={size} height={size} className={styles.mark} />
      <span className={styles.name} style={{ fontSize: size * 0.86 }}>
        Ronin
      </span>
    </span>
  )
}
